import { teamHonors, personalHonors } from '@/mocks/articles';

export default function HonorsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            荣誉殿堂
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            郝海东职业生涯中获得的重要荣誉和成就
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-5 flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-team-line"></i>
              </span>
              团队荣誉
            </h3>
            <div className="flex flex-col gap-3">
              {teamHonors.map((honor) => (
                <div
                  key={honor.title}
                  className="flex items-center justify-between bg-background-100 rounded-lg p-4 border border-background-200/70"
                >
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-900">
                      {honor.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {honor.years}
                    </p>
                  </div>
                  <span className="inline-flex px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold whitespace-nowrap">
                    {honor.count}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-5 flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-user-star-line"></i>
              </span>
              个人荣誉
            </h3>
            <div className="flex flex-col gap-3">
              {personalHonors.map((honor) => (
                <div
                  key={honor.title}
                  className="flex items-center justify-between bg-background-100 rounded-lg p-4 border border-background-200/70"
                >
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-900">
                      {honor.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-0.5">
                      {honor.years}
                    </p>
                  </div>
                  <span className="inline-flex px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-bold whitespace-nowrap">
                    {honor.count}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}